import React from 'react'

import { Card, CardContent, Table, TableBody, TableRow, TableCell, TextField, Typography } from '@material-ui/core'

export const DemandManager = ({ options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { DM } = options
  const { CUSTOMER_ID } = DM
  const { DOM, INTL } = CUSTOMER_ID
  const { STRING } = validation
  const { LENGTH } = STRING

  const displayCustomerIdTable = () => {
    return (
      <Card>
        <CardContent>
          <Table size='small' aria-label='demand-manager-customer-id-table'>
            <TableBody>
              <TableRow>
                <TableCell style={{ width: '180px' }}><Typography variant='h5'>Domestic Customer ID</Typography></TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    margin='none'
                    placeholder='Domestic Customer ID'
                    value={DOM}
                    error={errors.DEMAND_MANAGER_CID_DOM}
                    helperText={errors.DEMAND_MANAGER_CID_DOM && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      DM.CUSTOMER_ID.DOM = value
                      setErrors({ ...errors, DEMAND_MANAGER_CID_DOM: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, DM })
                      setAllOptions({ ...allOptions, DM })
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ width: '180px' }}><Typography variant='h5'>International Customer ID</Typography></TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    margin='none'
                    placeholder='International Customer ID'
                    value={INTL}
                    error={errors.DEMAND_MANAGER_CID_INTL}
                    helperText={errors.DEMAND_MANAGER_CID_INTL && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      DM.CUSTOMER_ID.INTL = value
                      setErrors({ ...errors, DEMAND_MANAGER_CID_INTL: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, DM })
                      setAllOptions({ ...allOptions, DM })
                    }}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    )
  }

  return (
    displayCustomerIdTable()
  )
}
